import { toast } from "sonner";
import { DealerRequestModel } from "../../domain/models/dealerModel";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function AddRequestToRoute(
  routes: RouteModel[],
  dealers: DealerRequestModel[],
  dropResult: DropResult,
): { routes: RouteModel[]; dealers: DealerRequestModel[] } {
  if (!dropResult.destination) {
    return {
      routes,
      dealers,
    };
  }

  // Get the draggable element and remove it from the existing place.
  const draggable = dropResult.draggableId;
  const requestId = draggable.replace("new-request:", "");

  const request = dealers
    .flatMap((d) => d.deliver_requests)
    .find((r) => r.id === requestId);
  if (!request) {
    toast.error("Could not find request:" + requestId + " to add");
    return {
      routes,
      dealers,
    };
  }

  dealers = dealers.filter((d) => {
    d.deliver_requests = d.deliver_requests.filter((r) => r.id !== request.id);
    return d.deliver_requests.length > 0;
  });

  // Get the destination element and add the draggable in the right place.
  const destination = dropResult.destination.droppableId;
  const routeId = destination.replace("route:", "");

  routes = routes.map((route) => {
    if (route.id === routeId) {
      const packingSlip = route.packingSlips.find(
        (slip) => slip.relation.id === request.relation.id,
      );
      if (packingSlip) {
        packingSlip.requests.push(request);
      } else {
        route.packingSlips.push({
          id: "state:" + route.truck?.id + "-" + request.relation.id,
          requests: [request],
          relation: request.relation,
          status: "draft",
          date: route.date,
        });
      }
    }

    return route;
  });

  return {
    routes,
    dealers,
  };
}
